import { render, staticRenderFns } from "./ImageSwitch.vue?vue&type=template&id=0513b22b&scoped=true"
import script from "./ImageSwitch.vue?vue&type=script&lang=js"
export * from "./ImageSwitch.vue?vue&type=script&lang=js"
import style0 from "./ImageSwitch.vue?vue&type=style&index=0&id=0513b22b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0513b22b",
  null
  
)

export default component.exports